import validator from "validator";

export function isEmailValid(email: string): boolean {
  if (!email) return false;
  if (email.length === 0) return false;

  // Check for phone number format (+1 prefix)
  if (isPhoneNumberFormat(email)) {
    return false;
  }

  // Use our enhanced regex instead of Zod's potentially too-strict validation
  return validator.isEmail(email, {
    allow_utf8_local_part: true,
    blacklisted_chars: "",
  });
}

/**
 * Checks if an email appears to be a phone number (starts with +1)
 */
export function isPhoneNumberFormat(email: string): boolean {
  return email.trim().startsWith("+1");
}
